import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import ViewAsBanner from '../components/ViewAsBanner'
import { useUser } from '../context/UserContext'
import { isComercialAllowedPath, isComercialUser } from '../utils/gestionCampanaAccess'
import { canUsePermissionDebug } from '../utils/permissionDebug'

const LS_SIDEBAR_OPEN = 'mgc_layout_sidebar_open'

function readSidebarOpenFromStorage() {
  try {
    const v = localStorage.getItem(LS_SIDEBAR_OPEN)
    if (v === '0') return false
    if (v === '1') return true
  } catch {
    /* ignore */
  }
  return true
}

const Layout = () => {
  const { user, realUser } = useUser()
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(readSidebarOpenFromStorage)

  useEffect(() => {
    try {
      localStorage.setItem(LS_SIDEBAR_OPEN, sidebarOpen ? '1' : '0')
    } catch {
      /* ignore */
    }
  }, [sidebarOpen])

  const isDebugPath = location.pathname.startsWith('/debug-permisos')
  if (
    isComercialUser(user) &&
    !isComercialAllowedPath(location.pathname) &&
    !(isDebugPath && canUsePermissionDebug(realUser))
  ) {
    return <Navigate to="/panel-comercial" replace />
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        sidebarOpen={sidebarOpen}
        onToggleSidebar={() => setSidebarOpen((o) => !o)}
      />
      <Sidebar open={sidebarOpen} />
      <main
        className={`pt-12 p-6 transition-[margin] duration-200 ease-out ${sidebarOpen ? 'ml-64' : 'ml-0'}`}
      >
        <ViewAsBanner />
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
